import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';

export const RegistrationDetailsBackButton = (onClick: () => void) => {
  return html`
    <tr-flex
      horizontal
      crossaxis-center
      space="sm"
      ${css({ cursor: 'pointer', userSelect: 'none' })}
      @click=${() => {
        onClick();
      }}
    >
      <tr-icon> arrow_back </tr-icon>
      <tr-text> zurück </tr-text>
    </tr-flex>
  `;
};
